// analysis/deteccionMaleza/deteccionMalezaDataCards.jsx
import React from 'react';
import TablaIndicadoresMaleza from "../../components/TablaIndicadoresMaleza/TablaIndicadoresMaleza";

export const renderDeteccionMalezaDataCards = (validations, datosAnalisis, indicadores) => {
    // Obtener datos de lotes desde localStorage
    let lotesData = [];
    let shapefileUrl = null;
    let isCurrentAnalysis = false;
    let storedData = null;

    try {
        storedData = localStorage.getItem('deteccionMaleza_lotesData');
        if (storedData) {
            const parsedData = JSON.parse(storedData);

            // Verificar si es el nuevo formato con timestamp
            if (parsedData && typeof parsedData === 'object' && parsedData.data) {
                lotesData = parsedData.data;
                isCurrentAnalysis = parsedData.analysisCompleted === true;

                // Verificar que no sea muy antiguo (más de 1 hora)
                const oneHour = 60 * 60 * 1000;
                const isRecent = parsedData.timestamp && (Date.now() - parsedData.timestamp) < oneHour;
                if (!isRecent) {
                    isCurrentAnalysis = false;
                }
            } else {
                // Formato antiguo, considerarlo no válido
                lotesData = Array.isArray(parsedData) ? parsedData : [];
                isCurrentAnalysis = false;
            }
        }

        shapefileUrl = localStorage.getItem('deteccionMaleza_shapefileUrl');
    } catch (error) {
        console.error('Error al obtener datos desde localStorage:', error);
    }

    // Solo mostrar la tabla si hay análisis completo con datos válidos y es actual
    const hasValidAnalysisData = datosAnalisis &&
                                datosAnalisis.areaMaleza &&
                                datosAnalisis.areaPoligono &&
                                datosAnalisis.porcentajeMaleza &&
                                datosAnalisis.areaMaleza.valor !== undefined &&
                                datosAnalisis.areaPoligono.valor !== undefined &&
                                datosAnalisis.porcentajeMaleza.valor !== undefined;

    const shouldShowTable = lotesData && lotesData.length > 0 && hasValidAnalysisData && isCurrentAnalysis;


    return (
        <>
            {/* Tabla de indicadores por lote - Solo mostrar cuando hay análisis válido y actual */}
            {shouldShowTable && (
                <TablaIndicadoresMaleza
                    lotes_data={lotesData}
                    areaMalezaTotal={datosAnalisis.areaMaleza?.valor}
                    areaPoligonoTotal={datosAnalisis.areaPoligono?.valor}
                    porcentajeMalezaTotal={datosAnalisis.porcentajeMaleza?.valor}
                    shapefileUrl={shapefileUrl}
                />
            )}
        </>
    );
};
